import { routes as dashboard } from './dashboard';
import { routes as orders } from './orders';
import { routes as accounting } from './accounting';
import { routes as servicetickets } from './servicetickets';
import { routes as costcoservicerequests } from './costcoservicerequests';
import { routes as equipment } from './equipment';
import { routes as claims } from './claims';
import { routes as technicaldocumentation } from './technicaldocumentation';
import { routes as canadianTaxes } from './masters/canadiantaxes';
import { routes as complaintCodes } from './masters/complaintcodes';
import { routes as customerChains } from './masters/customerchains';
import { routes as customers } from './masters/customers';
import { routes as parts } from './masters/parts';
import { routes as products } from './masters/products';
import { routes as resolutionCodes } from './masters/resolutioncodes';
import { routes as serviceCompanies } from './masters/servicecompanies';
import { routes as emails } from './emails';
import { routes as users } from './masters/users';
import { routes as reports } from './reports';
import { routes as rma }  from './rma';
import { routes as FAQ } from './Faq';
import { routes as escalationList } from '../globalapp/escalationdashboard'

export default [...dashboard, ...orders, ...accounting, ...servicetickets, ...costcoservicerequests, ...equipment, ...claims, ...canadianTaxes, ...complaintCodes, ...reports,
...customerChains, ...customers, ...parts, ...products, ...resolutionCodes, ...serviceCompanies, ...users, ...technicaldocumentation, ...rma, ...FAQ, ...escalationList, ...emails ];


// WEBPACK FOOTER //
// ./ClientApp/app/routes.js